// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Tickets_CriaticketResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Tickets_CriaticketResponseDados {
ticket_id: number
message: string
}

export type Tickets_CriaticketResponse = ApiResponse<Tickets_CriaticketResponseDados>;

registerResponseContract('Tickets_CriaticketResponse', {
  ticket_id: { type: 'number',  required: false },
  message:   { type: 'string',  required: false },
})
